"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=base-uri.js.map